var mentions_default = {
  "mentionPalette": "Jp9zz",
  "mention": "TU2rj",
  "mentionViewer": "DAOQy",
  "mentionSuggestionsEntry": "uAJP6",
  "mentionSuggestionsEntryFocused": "nOb2O",
  "mentionSuggestionsEntryText": "t-zRd",
  "mentionSuggestionsEntryAvatar": "GXJRd",
  "mentionSuggestions": "lR6qw",
  "cursorDefault": "hHadM",
  "cursorPointer": "Iurjq"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
